// extracted by mini-css-extract-plugin
module.exports = {"bullet-list":"Dhq4VCT","bulletList":"Dhq4VCT"};